import Accounts from "../views/accounts/Accounts"
import Services from "../views/merchants/Services"
import BankAccounts from "../views/merchants/BankAccounts"
import Transactions from "../views/transactions/Transactions"
import BulkPayments from "../views/transactions/BulkPayments"
import TopUps from "../views/transactions/TopUps"
import Issues from "../views/Issues"
import CreateAccount from "../views/accounts/CreateAccount"
import ExportAccounts from "../views/accounts/ExportAccounts"
import Dashboard from "../views/Dashboard.vue"
import BankTransfers from "../views/transactions/BankTransfers.vue"
import BankTransfersAuto from "../views/transactions/BankTransfersAuto.vue"
import Operators from "../views/settings/Operators.vue"
import Banks from "../views/settings/Banks.vue"
import Currencies from "../views/settings/Currencies.vue"
import Roles from "../views/settings/Roles.vue"
import Rights from "../views/settings/Rights.vue"
import ServiceInconsistency from "../views/inconsistency/ServiceInconsistency.vue"
import CampostTransactions from "../views/transactions/CampostTransactions.vue"
import TresorPayPayments from '@/views/tresorpay/Payments.vue'
import Gateways from "@/views/settings/Gateways.vue"
import ExportTransactions from "@/views/transactions/ExportTransactions.vue"
import ExportTresorpayPayments from "@/views/tresorpay/ExportTresorpayPayments.vue"

export default [
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
  },
  {
    path: "/accounts",
    name: "accounts",
    component: {
      render(c) {
        return c("router-view")
      }
    },
    children: [
      {
        path: "users",
        name: "accounts.users",
        component: Accounts,
      },
      {
        path: "create",
        name: "accounts.create",
        component: CreateAccount,
      },
      {
        path: "export",
        name: "accounts.export",
        component: ExportAccounts,
      },
    ],
  },
  {
    path: "/transactions",
    name: "transactions",
    redirect: "/transactions/list",
    component: {
      render(c) {
        return c("router-view")
      }
    },
    children: [
      {
        path: "campost",
        name: "transactions.campost",
        component: CampostTransactions,
      },
      {
        path: "list",
        name: "transactions.list",
        component: Transactions,
      },
      {
        path: "bulk-payments",
        name: "transactions.bulk_payments",
        component: BulkPayments,
      },
      {
        path: "top-ups",
        name: "transactions.top_ups",
        component: TopUps,
      },
      {
        path: "bank-transfers/manual",
        name: "transactions.bank_transfers.manual",
        component: BankTransfers,
      },
      {
        path: "bank-transfers/auto",
        name: "transactions.bank_transfers.auto",
        component: BankTransfersAuto,
      },
      {
        path: "export",
        name: "transactions.export",
        component: ExportTransactions,
      },
    ]
  },
  {
    path: "/tresorpay",
    name: "tresorpay",
    redirect: "/tresorpay/payments",
    component: {
      render(c) {
        return c("router-view")
      }
    },
    children: [
      {
        path: "payments",
        name: "tresorpay.payments",
        component: TresorPayPayments,
      },
      {
        path: "export",
        name: "tresorpay.export",
        component: ExportTresorpayPayments,
      },
    ]
  },
  {
    path: "/issues",
    name: "issues",
    component: Issues,
  },
  {
    path: "/merchants",
    name: "merchants",
    redirect: "/merchants/services",
    component: {
      render(c) {
        return c("router-view")
      }
    },
    children: [
      {
        path: "services",
        name: "merchants.services",
        component: Services,
      },
      {
        path: "bank-accounts",
        name: "merchants.bank_accounts",
        component: BankAccounts,
      },
    ]
  },
  {
    path: "/settings",
    name: "settings",
    redirect: "/settings/operators",
    component: {
      render(c) {
        return c("router-view")
      }
    },
    children: [
      {
        path: "operators",
        name: "settings.operators",
        component: Operators,
      },
      {
        path: "gateways",
        name: "settings.gateways",
        component: Gateways,
      },
      {
        path: "banks",
        name: "settings.banks",
        component: Banks,
      },
      {
        path: "currencies",
        name: "settings.currencies",
        component: Currencies,
      },
      {
        path: "roles",
        name: "settings.roles",
        component: Roles,
      },
      {
        path: "rights",
        name: "settings.rights",
        component: Rights,
      },
    ]
  },
  {
    path: "/inconsistency",
    name: "inconsistency",
    redirect: "/inconsistency/services",
    component: {
      render(c) {
        return c("router-view")
      }
    },
    children: [
      {
        path: "services",
        name: "inconsistency.services",
        component: ServiceInconsistency,
      },
    ]
  },
]
